export enum ActivityLogType {
  LogMaxMin = 1,
  Log24h = 2,
  LogCurrent = 3,
}
